export const ConfirmAccessLossModal: string = 'ConfirmAccessLossModal';
